/*Package importing*/
import React, { useState } from 'react';

/*Import custom components and assets*/
import OTPWidgetForgotPassword from './forgotPasswordOTP';
import SetPassword from './setPassword';
import logo from '../../assets/images/logo.png';
import loginHero from '../../assets/images/login-hero.svg';
import H1 from '../../components/heading/h1';


import service from '../../services/service';

const ForgotPassword = () => {
    const [forgotPassword, setForgotPassword] = useState(true);
    const [data, setData] = useState({});
    const [mobile, setMobile] = useState("");
    const [loading, setLoading] = useState(false);
    const [otpAdded, setOtpAdded] = useState(false);
    const [tempToken, setTempToken] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const sendOTPClick = async () => {
        setLoading(true);
        if (!mobile) {
            setErrorMessage("All fields are mandatory.");
            setLoading(false);
            return false;
        }
        // call api
        var params = {
            "mobile": mobile
        };
        var response = await service(false, "admin/auth/forgot-password", params, false, false);
        if (response.status) {
            setForgotPassword(false);
            setLoading(false);
        } else {
            setErrorMessage(response.message);
            setLoading(false);
        }
    };

    const passwordSet = (response) => {
        window.location.href = '/';
    };

    return (
        <div className="e-body">
            <section className="e-login-section vh-100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 text-center mt-5">
                            <img src={logo} alt="Tranna admin logo" className="e-logo mt-5" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 offset-lg-3">
                            {
                                forgotPassword ?
                                    <div className="e-auth-widget-wrap">
                                        <H1 headOne="Forgot" headTwo="Password." />
                                        <dd className="e-input-contentbox mb-4">
                                            <input
                                                id="uName"
                                                type="number"
                                                autoComplete='off'
                                                value={mobile}
                                                onChange={(event) => { 
                                                    setMobile(event.target.value);
                                                    setErrorMessage("");
                                                }}
                                                required
                                                onKeyDown={(e) => e.keyCode === 13 && sendOTPClick()} />
                                            <label htmlFor="uName">Mobile</label>
                                        </dd>

                                        <div className="col-lg-12 e-error-red">
                                            {
                                                errorMessage
                                            }
                                        </div>
                                       
                                        <div className={`col-12 p-0 mt-4 ${loading === true ? "e-auth-loader" : ""}`}>
                                            <span className="e-p-btn e-auth-btn" onClick={sendOTPClick}>
                                                <div>Send OTP</div>
                                            </span>
                                        </div>
                                    </div>
                                    :
                                    otpAdded === false ?
                                        <OTPWidgetForgotPassword data={mobile}
                                            verifyOTPSuccess={(response) => {
                                                setOtpAdded(true);
                                                setTempToken(response.temp_token);
                                            }} />
                                        :
                                        <SetPassword token={tempToken}
                                            passwordSet={passwordSet} />
                            }
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ForgotPassword;